((ProductBuilder, $) => {
  'use strict';

  const $dom = {};
  const radix = 10;
  const purchase = {};
  let localEvents;
  let currentStep = 1;

  const cacheDom = () => {
    $dom.byo = $('.js-byo');
    $dom.step = $dom.byo.find('.js-byo-step');
    $dom.sideStep = $dom.byo.find('.js-byo-side-step');
    $dom.addToCart = $dom.byo.find('.js-byo-add-to-cart');
    $dom.back = $dom.byo.find('.js-byo-back');
    $dom.caseImage = $dom.byo.find('.js-byo-case-image');
    $dom.caseSelector = $dom.byo.find('.js-byo-case-selector');
    $dom.orificeImage = $dom.byo.find('.js-byo-orifice-image');
    $dom.orificeSelector = $dom.byo.find('.js-byo-orifice-selector');
    $dom.textureImage = $dom.byo.find('.js-byo-texture-image');
    $dom.accessoryImage = $dom.byo.find('.js-byo-accessory-image');
    $dom.textureSelector = $dom.byo.find('.js-byo-texture-selector');
    $dom.accessorySelector = $dom.byo.find('.js-byo-accessory-selector');
    $dom.nextStep = $dom.byo.find('.js-byo-next-step');
    $dom.productView = $dom.byo.find('.js-byo-product-view');
    $dom.checkmark = $dom.byo.find('.js-byo-checkmark');
    $dom.startOver = $dom.byo.find('.js-start-over');
    $dom.step5 = $dom.byo.find('.js-byo-side-step-5');
    $dom.step5Header = $dom.byo.find('.js-byo-header-step-5');
    $dom.step5Block = $dom.byo.find('.js-byo-build-block-step-5');
    $dom.mobileNextStep = $dom.byo.find('.js-byo-mobile-next-step');
    $dom.mobileSlider = $dom.byo.find('.js-mobile-build-slider');
    $dom.nav = $('.js-main-navigation');
    $dom.mobileButtonContainer = $dom.byo.find('.js-byo-mobile-button-container');
    $dom.mobileButtonWrapper = $dom.mobileButtonContainer.find('.js-byo-mobile-button-wrapper');
    $dom.buildContainer = $dom.byo.find('.js-byo-build-container');
    $dom.topBar = $dom.byo.find('.js-byo-top-bar');
    $dom.globalTopBanner = $('.top-banner');
    $dom.topBarText = $dom.byo.find('.js-byo-top-bar-text');
    $dom.stepExplanation = $dom.byo.find('.js-byo-step-explanation');
    $dom.sensationEntry = $dom.byo.find('.js-byo-step-explanation-sensation');
    $dom.bestSeller = $dom.byo.find('.js-byo-sensation-best-seller');
    $dom.mobileStartOver = $dom.byo.find('.js-byo-mobile-start-over');
    $dom.price = $dom.byo.find('.js-byo-price');
    $dom.accessoryImageContainer = $dom.byo.find('.js-byo-accessory-view');
    $dom.explanationSelectionText = $dom.byo.find('.js-step-explanation-selection-text');
    $dom.accessoryExplanationContainer = $dom.byo.find('.js-byo-explanation-accessory-container');
    $dom.accessoryBtn = $dom.byo.find('.js-byo-accessory-btn');
    $dom.setStep = $dom.byo.find('.js-byo-set-step');
    $dom.step5text = $dom.byo.find('.js-byo-build-name-step-5-text');
    $dom.caseSideImage = $dom.byo.find('.js-byo-case-side-image');
    $dom.window = $(window);
    $dom.mobileTopText = $('.js-byo-mobile-top-text');
  };

  const convertCentsToDollars = cents => (cents / 100.0).toFixed(2);

  const adjustPage = () => {
    const adjustPageInterval = setInterval(() => {
      if ($(window).width() < 992) {
        const windowHeight = $(window).height();
        let removableHeight = $dom.nav.outerHeight() +
          $dom.mobileButtonContainer.outerHeight() +
          $dom.buildContainer.outerHeight() +
          $dom.topBar.outerHeight();
        if ($('body').hasClass('holiday-body')) {
          removableHeight += $dom.globalTopBanner.outerHeight();
        }

        $dom.productView.height(windowHeight - removableHeight);

        if ($dom.mobileButtonContainer.find('.slick-initialized').length) {
          clearInterval(adjustPageInterval);
        }
      } else {
        clearInterval(adjustPageInterval);
        $dom.productView.attr('style', '');
      }
    }, 500);
  };

  const adjustPrice = () => {
    let priceInCents = parseInt($dom.textureSelector.first().attr('data-price'), radix);
    if (purchase.accessories && purchase.accessories.length) {
      purchase.accessories.forEach((item) => {
        priceInCents += item.price;
      });
    }

    if (window.Geolizr && window.GeolizrAPI && window.GeolizrAPI.api) {
      $dom.price.find('[data-geolizr-price]').attr('data-geolizr-price', priceInCents);
      const currency = window.GeolizrAPI.api.getCurrency();
      window.GeolizrAPI.api.switchCurrency(currency);
    } else {
      $dom.price.text(`$${convertCentsToDollars(priceInCents)}`);
    }
  };

  const showStepItem = ($element, step, className) => {
    $element.removeClass(className)
      .filter(`[data-step="${step}"]`)
      .addClass(className);
  };

  const renderStep = (step) => {
    const stepToUse = step || currentStep;
    let view;
    if (stepToUse === 3) {
      view = 'texture';
    } else if (stepToUse === 4) {
      view = 'accessory';
    } else {
      view = 'orifice';
    }

    if (stepToUse === 5) {
      $dom.mobileStartOver.removeClass('hidden');
      $dom.addToCart.addClass('clickable');
    } else {
      $dom.mobileStartOver.addClass('hidden');
    }
    showStepItem($dom.sideStep, stepToUse, 'visible');
    $dom.productView.removeClass('visible')
      .filter(`[data-product-view="${view}"]`)
      .addClass('visible');
    showStepItem($dom.step, stepToUse, 'current');
    showStepItem($dom.mobileNextStep, stepToUse, 'visible');
    showStepItem($dom.topBarText, stepToUse, 'visible');
    showStepItem($dom.stepExplanation, stepToUse, 'visible');
    $dom.mobileButtonWrapper
      .hide()
      .filter(`[data-step="${stepToUse}"]`)
      .show()
      .css('display', 'flex');
    $dom.mobileTopText
      .hide()
      .filter(`[data-step="${step}"]`)
      .show();;
    localEvents.emit('stepChangeComplete');
  };

  const decrimentStep = () => {
    currentStep -= 1;
    if (currentStep < 1) {
      currentStep = 1;
    }
    localEvents.emit('stepChange', currentStep);
  };

  const incrementStep = () => {
    currentStep += 1;
    if (currentStep > 5) {
      currentStep = 5;
    }
    localEvents.emit('stepChange', currentStep);
  };

  const setStep = (step) => {
    currentStep = step;
    localEvents.emit('stepChange', currentStep);
  };

  const selectCase = (fCase, imageUrl) => {
    $dom.caseImage.removeClass('visible')
      .filter(`[data-case="${fCase}"]`)
      .addClass('visible');
    $dom.caseSideImage.removeClass('visible')
      .filter(`[data-case="${fCase}"]`)
      .addClass('visible');
    purchase.case = purchase.case || {};
    purchase.case.value = fCase;
    purchase.case.imageUrl = imageUrl;
  };

  const selectOrifice = (orifice, imageUrl) => {
    $dom.orificeImage.removeClass('visible')
      .filter(`[data-orifice="${orifice}"]`)
      .addClass('visible');
    purchase.orifice = purchase.orifice || {};
    purchase.orifice.value = orifice;
    purchase.orifice.imageUrl = imageUrl;
  };

  const selectTexture = (texture, variantId, imageUrl, title, bestSeller) => {
    $dom.textureImage.removeClass('visible')
      .filter(`[data-texture="${texture}"]`)
      .addClass('visible');
    purchase.texture = purchase.texture || {};
    purchase.texture.value = texture;
    purchase.texture.id = variantId;
    purchase.texture.imageUrl = imageUrl;
    purchase.texture.title = title;
    $dom.sensationEntry.text(title);
    if (bestSeller) {
      $dom.bestSeller.show().css('display', 'inline');
    } else {
      $dom.bestSeller.hide();
    }
  };

  const selectAccessory = (accessoryId, imageUrl, title, price, handle) => {
    $dom.accessoryImage.removeClass('visible')
      .filter(`[data-accessory="${handle}"]`)
      .addClass('visible');
    purchase.accessories = purchase.accessories || [];
    let found = false;
    for (let i = 0; i < purchase.accessories.length; i++) {
      if (purchase.accessories[i].id === accessoryId) {
        found = true;
        break;
      }
    }
    if (!found) {
      purchase.accessories.push({
        id: accessoryId,
        imageUrl,
        title,
        price
      });
    } else {
      purchase.accessories = purchase.accessories.filter(accessory => accessory.id !== accessoryId);
    }
  };

  const setSliders = () => {
    const SliderOptions = class {
      constructor() {
        this.infinite = false;
        this.slidesToShow = 4;
        this.swipeToSlide = true;
        this.arrows = false;
        this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>';
        this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>';
      }
    };

    if ($(window).width() < 992) {
      $dom.mobileSlider.filter('.slick-initialized').each(function checkLengthSetSlick() {
        if ($(this).find('.byo--build-block').not('.hidden').length > 4) {
          $(this).slick('unslick').slick(new SliderOptions());
          $(this).slick('slickUnfilter');
          $(this).slick('slickFilter', ':not(.hidden)');
        } else {
          $(this).removeClass('byo--slider').slick('unslick');
        }
      });

      $dom.mobileSlider.not('.slick-initialized').each(function checkLengthSetSlick() {
        if ($(this).find('.byo--build-block').not('.hidden').length > 4) {
          $(this).addClass('byo--slider').slick(new SliderOptions());
          $(this).slick('slickUnfilter');
          $(this).slick('slickFilter', ':not(.hidden)');
        }
      });
    } else {
      $dom.mobileSlider.filter('.slick-initialized').each(function removeInitializedState() {
        $(this).removeClass('byo--slider').slick('unslick');
      });
    }

    if (currentStep === 4) {
      const options = new SliderOptions();
      options.slidesToShow = 1;
      options.arrows = true;
      if ($dom.accessoryImageContainer.hasClass('slick-initialized')) {
        options.initialSlide = parseInt($dom.accessorySelector.filter('.slide-selected').attr('data-slide'), radix) - 1;
        $dom.accessoryImageContainer.slick('unslick').slick(options);
      } else {
        $dom.accessoryImageContainer.slick(options);
      }
    }
  };

  const toggleCheckmark = ($self) => {
    if (!$self.hasClass('js-byo-accessory-selector')) {
      $self.siblings().find('.js-byo-checkmark').removeClass('active');
      $self.find('.js-byo-checkmark').addClass('active');
    } else {
      $self.find('.js-byo-checkmark').toggleClass('active');
    }
  };

  const startOver = (event) => {
    if (event) {
      event.preventDefault();
    }
    delete purchase.case;
    delete purchase.orifice;
    delete purchase.texture;
    delete purchase.accessories;
    $dom.addToCart.removeClass('clickable');
    $dom.orificeImage.removeClass('visible');
    $dom.caseImage
      .removeClass('visible')
      .filter('.js-byo-case-image')
      .first()
      .addClass('visible');
    $dom.textureImage.removeClass('visible');
    setStep(1);
    $dom.checkmark.removeClass('active');
    $dom.step.removeClass('selected');
    $dom.sensationEntry.text('');
    $dom.bestSeller.hide();
    $dom.back.addClass('hidden');
    $dom.mobileStartOver.addClass('hidden');
    $dom.nextStep.filter('[data-toggleable]').addClass('disabled');
    $dom.step5Block.filter('[data-type="accessories"]').addClass('hidden');
    $dom.explanationSelectionText
      .filter('[data-selected="selected"]')
      .hide();
    $dom.explanationSelectionText
      .filter('[data-selected="not-selected"]')
      .show();
    adjustPrice();
  };

  const addItemsToCart = ($self) => {
    if (!$self.hasClass('clickable')) {
      return false;
    }

    window.CartJS.addItem(purchase.texture.id, 1, {
      case: purchase.case.value,
      orifice: purchase.orifice.value,
      texture: purchase.texture.value
    });

    if (purchase.accessories) {
      purchase.accessories.forEach((accessory) => {
        window.CartJS.addItem(accessory.id, 1, {}, {});
      });
    }

    window.InlineCart.triggerInlineCart();
    return true;
  };

  const setStepSelectedState = (step, isAccessories) => {
    if (!isAccessories) {
      $dom.step.filter(`[data-step="${step}"]`).addClass('selected');
      $dom.mobileNextStep.filter(`[data-step="${step}"]`).removeClass('unclickable');
      $dom.nextStep.filter(`[data-step="${step}"]`).removeClass('disabled');
      return true;
    }

    if (purchase.accessories.length) {
      $dom.step.filter(`[data-step="${step}"]`).addClass('selected');
      $dom.accessoryBtn.removeClass('no-accessory');
    } else {
      $dom.step.filter(`[data-step="${step}"]`).removeClass('selected');
      $dom.accessoryBtn.addClass('no-accessory');
    }
    return true;
  };

  const setStep5Block = (type, imageUrl) => {
    if (type !== 'accessory') {
      $dom.step5Block
        .filter(`[data-type="${type}"]`)
        .removeClass('hidden')
        .find('.js-byo-build-image-step-5')
        .attr('src', imageUrl);
      return true;
    }

    return true;
  };

  const setStep5Accessories = () => {
    $dom.step5Block
      .filter('[data-type="accessories"]')
      .addClass('hidden');
    purchase.accessories.forEach((item) => {
      $dom.step5Block
        .filter('[data-type="accessories"]')
        .filter(`[data-variant-id="${item.id}"]`)
        .removeClass('hidden');
    });
  };

  const setStep5 = () => {
    let headerText = '';
    if (purchase.case) {
      headerText += `${purchase.case.value} case`;
      setStep5Block('case', purchase.case.imageUrl);
    }

    if (purchase.orifice) {
      headerText += headerText.length ? ` - ${purchase.orifice.value}` : purchase.orifice;
      setStep5Block('orifice', purchase.orifice.imageUrl);
    }

    if (purchase.texture) {
      headerText += headerText.length ? ` - ${purchase.texture.value}` : purchase.texture.value;
      setStep5Block('texture', purchase.texture.imageUrl);
    }

    if (purchase.accessories) {
      purchase.accessories.forEach((accessory) => {
        headerText += headerText.length ? ` - ${accessory.title}` : accessory.title;
      });
      setStep5Accessories();
    }

    $dom.byo.find('.js-byo-header-insertion-step-5').text(headerText);
  };

  const setSlide = (slide) => {
    const goTo = parseInt(slide, radix) - 1;
    $dom.accessoryImageContainer.slick('slickGoTo', goTo);
  };

  const setLocalEvents = () => {
    localEvents = new window.PubSub.Create('ProductBuilder');
    localEvents.on('stepChange', renderStep);
    localEvents.on('stepChangeComplete', setSliders);
  };

  const setExplanationText = (filter, value) => {
    const $text = $dom.explanationSelectionText.filter(`[data-type="${filter}"]`);
    $text.filter('[data-selected="not-selected"]').hide();
    $text.filter('[data-selected="selected"]').find('.js-step-explanation-insertion').text(value);
    $text.filter('[data-selected="selected"]').show();
  };

  const bindUIActions = () => {
    $dom.back.on('click', decrimentStep);

    $dom.caseSelector.on('click', function selectCaseOnClick(event) {
      event.preventDefault();
      const $self = $(this);
      const fCase = $self.attr('data-case');
      const step = $self.attr('data-step');
      const imageUrl = $self.attr('data-image');
      selectCase(fCase, imageUrl);
      toggleCheckmark($self);
      setStepSelectedState(step);
      setStep5();
      setExplanationText('case', fCase);
      $dom.step5text.filter(`[data-type="${'case'}"]`).text(fCase);
    });

    $dom.orificeSelector.on('click', function selectOrificeOnClick(event) {
      event.preventDefault();
      const $self = $(this);
      const orifice = $self.attr('data-orifice');
      const step = $self.attr('data-step');
      const imageUrl = $self.attr('data-image');
      selectOrifice(orifice, imageUrl);
      toggleCheckmark($self);
      setStepSelectedState(step);
      setStep5();
      setExplanationText('orifice', orifice);
      $dom.step5text.filter(`[data-type="${'orifice'}"]`).text(orifice);
    });

    $dom.textureSelector.on('click', function selectTextureOnClick(event) {
      event.preventDefault();
      const $self = $(this);
      const texture = $self.attr('data-texture');
      const variantId = $self.attr('data-variant-id');
      const step = $self.attr('data-step');
      const imageUrl = $self.attr('data-image');
      const title = $self.attr('data-title');
      const bestSeller = $self.attr('data-best-seller');
      selectTexture(texture, variantId, imageUrl, title, bestSeller);
      toggleCheckmark($self);
      setStepSelectedState(step);
      setStep5();
      setExplanationText('texture', texture);
      $dom.step5text.filter(`[data-type="${'texture'}"]`).text(texture);
    });

    $dom.accessorySelector.on('click', function selectAccessoryOnClick(event) {
      event.preventDefault();
      const $self = $(this);
      const variantId = $(this).attr('data-variant-id');
      const step = $self.attr('data-step');
      const imageUrl = $self.attr('data-image');
      const title = $self.attr('data-title');
      const price = parseInt($self.attr('data-price'), radix);
      const handle = $self.attr('data-handle');
      const slide = $self.attr('data-slide');
      selectAccessory(variantId, imageUrl, title, price, handle);
      toggleCheckmark($self);
      setStepSelectedState(step, true);
      setStep5();
      adjustPrice();
      setSlide(slide);
      $dom.accessoryExplanationContainer
        .filter(`[data-handle="${handle}"]`)
        .find('.js-step-explanation-selection-text')
        .toggle();
    });

    $dom.nextStep.on('click', (event) => {
      event.preventDefault();
      incrementStep();
    });

    $dom.startOver.on('click', startOver);

    $dom.addToCart.on('click', function addItemsToCartOnClick(event) {
      event.preventDefault();
      addItemsToCart($(this));
    });

    $dom.accessoryImageContainer.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $dom.accessorySelector
        .removeClass('slide-selected')
        .filter(`[data-slide="${nextSlide + 1}"]`)
        .addClass('slide-selected');
      $dom.accessoryExplanationContainer
        .hide()
        .filter(`[data-slide="${nextSlide + 1}"]`)
        .show();
    });

    $dom.setStep.on('click', function setStepOnClick(event) {
      event.preventDefault();
      const step = parseInt($(this).attr('data-step'), radix);
      setStep(step);
    });

    $dom.window.on('resize', () => {
      setSliders();
      adjustPage();
    });
  };

  const init = () => {
    cacheDom();
    setLocalEvents();
    bindUIActions();
    setSliders();
    adjustPage();
  };

  ProductBuilder.init = init;
})(window.ProductBuilder = window.ProductBuilder || {}, jQuery);
